<div class="w-full">
  <h5 class="text-gray-900 mb-4 font-medium">{{ title | translateKey }}</h5>

  <div
    *ngIf="!options || options.length === 0"
    class="w-full border rounded-lg p-4 cursor-default transition-all bg-gray-50/50 flex items-center justify-center"
    style="border-color: rgb(218, 227, 236); min-height: 80px"
  >
    <div class="flex items-center justify-center w-full">
      <p class="text-gray-500 m-0 text-center">
        {{
          languageKey.EMPTY_REGISTERS_OF
            | translateKey
            | formatTranslate: registerType
        }}
      </p>
    </div>
  </div>

  <div class="w-full" *ngIf="options && options.length > 0">
    <p-selectButton
      [options]="options"
      [ngModel]="modelValue()"
      (onChange)="onSelectChange($event)"
      [multiple]="multiple"
      dataKey="id"
    >
      <ng-template pTemplate="item" let-item>
        <div
          class="custom-tag-button"
          [style.backgroundColor]="isItemSelected(item) ? item.color : 'white'"
          [style.borderColor]="isItemSelected(item) ? item.color : '#d1d5db'"
          [style.color]="isItemSelected(item) ? '#ffffff' : '#374151'"
        >
          <!-- //TODO, resolver cores troca de tema -->
          {{ item.name | translateKey }}
        </div>
      </ng-template>
    </p-selectButton>
  </div>
</div>
